import { COUPON_FETCH } from './types';
import axios from 'axios';

export const couponFetch = (amwayNumber, partyId) => dispatch => {
  axios.post(`${process.env.REACT_APP_API_URL}/coupons/${amwayNumber}`, {},{
    headers: {
      'Authorization': 'Bearer dummy',
      account: amwayNumber,
      customer: partyId,
    }
  }).then(res => {
    dispatch({
      type: COUPON_FETCH,
      payload: res.data,
    });
  });
};
